import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-atlas-navy-dark text-white/80 text-sm mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div>
          AtlasGeo Technologies LLC &middot; SDVOSB / MBE
        </div>
        <div className="flex flex-wrap gap-5">
          <Link to="/privacy" className="text-white/80 hover:text-atlas-gold no-underline">Privacy</Link>
          <Link to="/about" className="text-white/80 hover:text-atlas-gold no-underline">About</Link>
          <a href="https://maptrium.com/" className="text-white/80 hover:text-atlas-gold no-underline">MAPTRIUM</a>
          <a href="https://maptrium.com/login" className="text-white/80 hover:text-atlas-gold no-underline">Sign in</a>
        </div>
      </div>
    </footer>
  );
}
